import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {map} from "rxjs/operators";

import {LorenGeofencingCircle} from "../../interfaces/loren-geofencing-circle.interface";
import {
    LorenGeofencingCircleService
} from "../../services/loren-geofencing-circle-service/loren-geofencing-circle.service";
import {BaseEntitiesResolver} from "../../../../shared/resolvers/loren-base-entities-resolver/base-entities.resolver";

@Injectable()
export class LorenGeofencingAllCirclesResolver extends BaseEntitiesResolver<LorenGeofencingCircle> {
    protected service = inject(LorenGeofencingCircleService);
    protected router = inject(Router);

    resolve() {
        return this.service.query().pipe(map((res) => res.items));
    }
}
